import type { BaseBlockProps } from '../../defs/block';

export type GrassBlockID = 'grass';

export type GrassBlockType = 'grass';

export type GrassBlockOptionDef = {
  count: number;
};

export type GrassBlockProps = Omit<BaseBlockProps, 'options' | 'optionType'> & {
  type: GrassBlockType;
  options: GrassBlockOptionDef[];
  optionType: 'list';
};

export const grassBlockProps: Record<GrassBlockID, GrassBlockProps> = {
  grass: {
    id: 'gr',
    type: 'grass',
    overlay: true,
    immobile: true,
    bind: true,
    options: [{ count: 2 }, { count: 1 }],
    optionType: 'list',
  },
};
